import * as types from '../types';
import * as Sentry from '@sentry/browser';

const INITIAL_STATE = {
  sign: null,
  amount: null,
  currency: {
    id: null,
    name: null,
  },
  shopOrderId: null,
  description: null,
  payWay: null,
  addOns: null,

  verified: false,
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.INIT_PAYMENT: {
      const {
        amount = null,
        currency: currencyId = null,
        shop_order_id: shopOrderId = null,
        description = null,
        sign = null,
        email = null,
        payway,
        shop_id,
        ...addOns
      } = action.payload;

      Sentry.setTag('shop_id', shop_id);

      return {
        ...state,
        sign,
        amount,
        currency: {
          ...state.currency,
          id: currencyId,
          name: null,
        },
        shopOrderId,
        description,
        email,
        addOns,
        initialPayWay: payway || null,

        payWay: null,
        verified: false,
      };
    }
    case types.VERIFICATION_SUCCESS: {
      const { ccyAlias: name } = action.payload;

      return {
        ...state,
        currency: {
          ...state.currency,
          name,
        },
        verified: true,
      };
    }
    case types.SET_PAYMENT_PAY_WAY: {
      return {
        ...state,
        payWay: action.payload,
      };
    }
    default:
      return state;
  }
}
